import axios from "axios"
import Client from "../client/ApiClient"
import { getAuthLocal } from "../../lib/localstorage"

const base = "surveillance/"

const getDashboardOverview = () => Client.get(`${base}dashboard/overview/`)

const getDashboardAlerts = () => Client.get(`${base}dashboard/alerts/`)

const getDashboardWorklist = (params) => Client.get(`${base}dashboard/worklist/`, { params })

const getDeviceReconcileWorklist = (params) => Client.get(`${base}dashboard/device-reconcile/`, { params })

const acknowledgeDeviceReconcile = (episodeId, dailyId) =>
  Client.post(`${base}episodes/${episodeId}/daily-records/${dailyId}/acknowledge-device-reconcile/`, {})

const createReportExport = (data) => Client.post(`${base}reports/export/`, data)

const getReportHaiSummary = (params) => Client.get(`${base}reports/hai-summary/`, { params })

const getReportVae = (params) => Client.get(`${base}reports/vae/`, { params })

const getReportClabsi = (params) => Client.get(`${base}reports/clabsi/`, { params })

const getReportCauti = (params) => Client.get(`${base}reports/cauti/`, { params })

const getReportDenominators = (params) => Client.get(`${base}reports/denominators/`, { params })

const getReportBytSummary = (params) => Client.get(`${base}reports/byt-summary/`, { params })

const getDeviceDaySummaries = (params) => Client.get(`${base}device-day-summaries/`, { params })

const recomputeDeviceDays = (data) => Client.post(`${base}device-day-summaries/recompute/`, data)

const getCensusSnapshots = (params) => Client.get(`${base}census-snapshots/`, { params })

const getEpisodes = (params) => Client.get(`${base}episodes/`, { params })

const getPatients = (params) => Client.get(`${base}patients/`, { params })

const createPatient = (data) => Client.post(`${base}patients/`, data)

const getPatient = (patientId) => Client.get(`${base}patients/${patientId}/`)

const updatePatient = (patientId, data) => Client.patch(`${base}patients/${patientId}/`, data)

const createEpisode = (data) => Client.post(`${base}episodes/`, data)

const getEpisode = (episodeId) => Client.get(`${base}episodes/${episodeId}/`)

const updateEpisode = (episodeId, data) => Client.patch(`${base}episodes/${episodeId}/`, data)

const getEpisodeConclusion = (episodeId) => Client.get(`${base}episodes/${episodeId}/final-conclusion/`)

const saveEpisodeConclusion = (episodeId, data) => Client.post(`${base}episodes/${episodeId}/final-conclusion/`, data)

const getEpisodeConclusionSuggestion = (episodeId) =>
  Client.get(`${base}episodes/${episodeId}/final-conclusion/suggestion/`)

const getDailyRecords = (episodeId) => Client.get(`${base}episodes/${episodeId}/daily-records/`)

const createDailyRecord = (episodeId, data) => Client.post(`${base}episodes/${episodeId}/daily-records/`, data)

const updateDailyRecord = (episodeId, dailyId, data) =>
  Client.patch(`${base}episodes/${episodeId}/daily-records/${dailyId}/`, data)

const submitDailyRecord = (episodeId, dailyId) =>
  Client.post(`${base}episodes/${episodeId}/daily-records/${dailyId}/submit/`, {})

const getDeviceEpisodes = (episodeId) => Client.get(`${base}episodes/${episodeId}/device-episodes/`)

const createDeviceEpisode = (episodeId, data) => Client.post(`${base}episodes/${episodeId}/device-episodes/`, data)

const updateDeviceEpisode = (episodeId, deviceId, data) =>
  Client.patch(`${base}episodes/${episodeId}/device-episodes/${deviceId}/`, data)

const deleteDeviceEpisode = (episodeId, deviceId) =>
  Client.delete(`${base}episodes/${episodeId}/device-episodes/${deviceId}/`)

const getMicrobiologyResults = (episodeId) => Client.get(`${base}episodes/${episodeId}/microbiology-results/`)

const createMicrobiologyResult = (episodeId, data) => Client.post(`${base}episodes/${episodeId}/microbiology-results/`, data)

const updateMicrobiologyResult = (episodeId, microbiologyId, data) =>
  Client.patch(`${base}episodes/${episodeId}/microbiology-results/${microbiologyId}/`, data)

const deleteMicrobiologyResult = (episodeId, microbiologyId) =>
  Client.delete(`${base}episodes/${episodeId}/microbiology-results/${microbiologyId}/`)

const getSurgeryEpisodes = (episodeId) => Client.get(`${base}episodes/${episodeId}/surgery-episodes/`)

const createSurgeryEpisode = (episodeId, data) => Client.post(`${base}episodes/${episodeId}/surgery-episodes/`, data)

const updateSurgeryEpisode = (episodeId, surgeryId, data) =>
  Client.patch(`${base}episodes/${episodeId}/surgery-episodes/${surgeryId}/`, data)

const deleteSurgeryEpisode = (episodeId, surgeryId) =>
  Client.delete(`${base}episodes/${episodeId}/surgery-episodes/${surgeryId}/`)

const getSurgeryWoundFollowUps = (episodeId, params) =>
  Client.get(`${base}episodes/${episodeId}/surgery-wound-follow-ups/`, { params })

const createSurgeryWoundFollowUp = (episodeId, data) =>
  Client.post(`${base}episodes/${episodeId}/surgery-wound-follow-ups/`, data)

const updateSurgeryWoundFollowUp = (episodeId, woundId, data) =>
  Client.patch(`${base}episodes/${episodeId}/surgery-wound-follow-ups/${woundId}/`, data)

const submitSurgeryWoundFollowUp = (episodeId, woundId) =>
  Client.post(`${base}episodes/${episodeId}/surgery-wound-follow-ups/${woundId}/submit/`, {})

const getCase = (caseId) => Client.get(`${base}cases/${caseId}/`)

const getCaseTimeline = (caseId) => Client.get(`${base}cases/${caseId}/timeline/`)

const getCaseComments = (caseId) => Client.get(`${base}cases/${caseId}/comments/`)

const createCaseComment = (caseId, data) => Client.post(`${base}cases/${caseId}/comments/`, data)

const getCaseAttachments = (caseId) => Client.get(`${base}cases/${caseId}/attachments/`)

const deleteCaseAttachment = (caseId, attachmentId) =>
  Client.delete(`${base}cases/${caseId}/attachments/${attachmentId}/`)

const uploadCaseAttachment = (caseId, file) => {
  const form = new FormData()
  form.append("file", file)
  const apiBase =
    process.env.REACT_APP_DOMAIN ||
    (process.env.REACT_APP_API_DOMAIN
      ? `${process.env.REACT_APP_API_DOMAIN.replace(/\/$/, "")}/`
      : "/api/v1/")
  return axios
    .post(`${apiBase}surveillance/cases/${caseId}/attachments/`, form, {
      headers: { Authorization: `Bearer ${getAuthLocal()?.token}` }
    })
    .then((res) => res.data)
}

const getWards = (params) => Client.get(`${base}master/wards/`, { params })

const createWard = (data) => Client.post(`${base}master/wards/`, data)

const updateWard = (id, data) => Client.patch(`${base}master/wards/${id}/`, data)

const deleteWard = (id) => Client.delete(`${base}master/wards/${id}/`)

const getAntibiotics = (params) => Client.get(`${base}master/antibiotics/`, { params })

const createAntibiotic = (data) => Client.post(`${base}master/antibiotics/`, data)

const updateAntibiotic = (id, data) => Client.patch(`${base}master/antibiotics/${id}/`, data)

const deleteAntibiotic = (id) => Client.delete(`${base}master/antibiotics/${id}/`)

const getOrganisms = (params) => Client.get(`${base}master/organisms/`, { params })

const createOrganism = (data) => Client.post(`${base}master/organisms/`, data)

const updateOrganism = (id, data) => Client.patch(`${base}master/organisms/${id}/`, data)

const deleteOrganism = (id) => Client.delete(`${base}master/organisms/${id}/`)

const getSpecimenTypes = (params) => Client.get(`${base}master/specimen-types/`, { params })

const createSpecimenType = (data) => Client.post(`${base}master/specimen-types/`, data)

const updateSpecimenType = (id, data) => Client.patch(`${base}master/specimen-types/${id}/`, data)

const deleteSpecimenType = (id) => Client.delete(`${base}master/specimen-types/${id}/`)

const getMdroDefinitions = (params) => Client.get(`${base}master/mdro-definitions/`, { params })

const createMdroDefinition = (data) => Client.post(`${base}master/mdro-definitions/`, data)

const updateMdroDefinition = (id, data) => Client.patch(`${base}master/mdro-definitions/${id}/`, data)

const deleteMdroDefinition = (id) => Client.delete(`${base}master/mdro-definitions/${id}/`)

const getInfectionTypes = (params) => Client.get(`${base}master/infection-types/`, { params })

const createInfectionType = (data) => Client.post(`${base}master/infection-types/`, data)

const updateInfectionType = (id, data) => Client.patch(`${base}master/infection-types/${id}/`, data)

const deleteInfectionType = (id) => Client.delete(`${base}master/infection-types/${id}/`)

const getCatheterTypes = (params) => Client.get(`${base}master/catheter-types/`, { params })

const createCatheterType = (data) => Client.post(`${base}master/catheter-types/`, data)

const updateCatheterType = (id, data) => Client.patch(`${base}master/catheter-types/${id}/`, data)

const deleteCatheterType = (id) => Client.delete(`${base}master/catheter-types/${id}/`)

const getSignals = (params) => Client.get(`${base}signals/`, { params })

const createSignal = (data) => Client.post(`${base}signals/`, data)

const getSignal = (signalId) => Client.get(`${base}signals/${signalId}/`)

const createCaseFromSignal = (signalId) => Client.post(`${base}signals/${signalId}/create-case/`, {})

const linkSignalToCase = (signalId, caseId) => Client.post(`${base}signals/${signalId}/link-case/`, { case_id: caseId })

const dismissSignal = (signalId, reason) => Client.post(`${base}signals/${signalId}/dismiss/`, { reason })

const getRules = (params) => Client.get(`${base}surveillance-rules/`, { params })

const createRule = (data) => Client.post(`${base}surveillance-rules/`, data)

const updateRule = (ruleId, data) => Client.patch(`${base}surveillance-rules/${ruleId}/`, data)

const deleteRule = (ruleId) => Client.delete(`${base}surveillance-rules/${ruleId}/`)

const testRule = (data) => Client.post(`${base}surveillance-rules/test/`, data)

const getCriteriaSets = (params) => Client.get(`${base}criteria-sets/`, { params })

const createCriteriaSet = (data) => Client.post(`${base}criteria-sets/`, data)

const updateCriteriaSet = (criteriaSetId, data) => Client.patch(`${base}criteria-sets/${criteriaSetId}/`, data)

const cloneCriteriaSetVersion = (criteriaSetId) => Client.post(`${base}criteria-sets/${criteriaSetId}/clone-version/`, {})

const getCriteriaItems = (criteriaSetId) => Client.get(`${base}criteria-sets/${criteriaSetId}/criteria/`)

const createCriteriaItem = (criteriaSetId, data) => Client.post(`${base}criteria-sets/${criteriaSetId}/criteria/`, data)

const updateCriteriaItem = (criteriaSetId, criteriaId, data) =>
  Client.patch(`${base}criteria-sets/${criteriaSetId}/criteria/${criteriaId}/`, data)

const deleteCriteriaItem = (criteriaSetId, criteriaId) =>
  Client.delete(`${base}criteria-sets/${criteriaSetId}/criteria/${criteriaId}/`)

const getCases = (params) => Client.get(`${base}cases/`, { params })

const createCase = (data) => Client.post(`${base}cases/`, data)

const getCaseDiagnoses = (caseId) => Client.get(`${base}cases/${caseId}/diagnosis/`)

const createCaseDiagnosis = (caseId, data) => Client.post(`${base}cases/${caseId}/diagnosis/`, data)

const previewCaseCriteria = (caseId, params) => Client.get(`${base}cases/${caseId}/criterion-preview/`, { params })

const getCaseCriterionOverview = (caseId, params) => Client.get(`${base}cases/${caseId}/criterion-overview/`, { params })

const getCaseCriterionSnapshots = (caseId) => Client.get(`${base}cases/${caseId}/criterion-snapshots/`)

const createCaseCriterionSnapshot = (caseId, data) => Client.post(`${base}cases/${caseId}/criterion-snapshots/`, data)

const transitionCase = (caseId, data) => Client.post(`${base}cases/${caseId}/transition/`, data)

const assignCase = (caseId, data) => Client.post(`${base}cases/${caseId}/assign/`, data)

const getCaseVaeAssessments = (caseId) => Client.get(`${base}cases/${caseId}/vae-assessments/`)

const createCaseVaeAssessment = (caseId, data) => Client.post(`${base}cases/${caseId}/vae-assessments/`, data)

const updateCaseVaeAssessment = (caseId, assessmentId, data) =>
  Client.patch(`${base}cases/${caseId}/vae-assessments/${assessmentId}/`, data)

const getCaseClabsiAssessments = (caseId) => Client.get(`${base}cases/${caseId}/clabsi-assessments/`)

const createCaseClabsiAssessment = (caseId, data) => Client.post(`${base}cases/${caseId}/clabsi-assessments/`, data)

const updateCaseClabsiAssessment = (caseId, assessmentId, data) =>
  Client.patch(`${base}cases/${caseId}/clabsi-assessments/${assessmentId}/`, data)

const getCaseCautiAssessments = (caseId) => Client.get(`${base}cases/${caseId}/cauti-assessments/`)

const createCaseCautiAssessment = (caseId, data) => Client.post(`${base}cases/${caseId}/cauti-assessments/`, data)

const updateCaseCautiAssessment = (caseId, assessmentId, data) =>
  Client.patch(`${base}cases/${caseId}/cauti-assessments/${assessmentId}/`, data)

const getAuditLogs = (params) => Client.get(`${base}audit-logs/`, { params })

const exportAuditLogs = (params) => Client.get(`${base}audit-logs/export/`, { params })

const getUserProfiles = () => Client.get(`${base}user-profiles/`)

const searchStaffForScope = (params) => Client.get(`${base}user-profiles/staff-search/`, { params })

const upsertUserProfile = (data) => Client.put(`${base}user-profiles/upsert/`, data)

const deleteUserProfile = (userId) => Client.delete(`${base}user-profiles/upsert/`, { data: { user_id: userId } })

const getClusters = (params) => Client.get(`${base}clusters/`, { params })

const getCluster = (clusterId) => Client.get(`${base}clusters/${clusterId}/`)

const createCluster = (data) => Client.post(`${base}clusters/`, data)

const transitionCluster = (clusterId, data) => Client.post(`${base}clusters/${clusterId}/transition/`, data)

const linkClusterCase = (clusterId, data) => Client.post(`${base}clusters/${clusterId}/link-case/`, data)

const openClusterFromSignal = (signalId) => Client.post(`${base}signals/${signalId}/open-cluster/`, {})

const getPeriodLocks = (params) => Client.get(`${base}reports/period-locks/`, { params })

const getPeriodReconciliation = (params) => Client.get(`${base}reports/period-reconciliation/`, { params })

const createPeriodLock = (data) => Client.post(`${base}reports/period-locks/`, data)

const SurveillanceRepository = {
  getDashboardOverview,
  getDashboardAlerts,
  getDashboardWorklist,
  getDeviceReconcileWorklist,
  acknowledgeDeviceReconcile,
  createReportExport,
  getReportHaiSummary,
  getReportVae,
  getReportClabsi,
  getReportCauti,
  getReportDenominators,
  getReportBytSummary,
  getDeviceDaySummaries,
  recomputeDeviceDays,
  getCensusSnapshots,
  getEpisodes,
  getPatients,
  createPatient,
  getPatient,
  updatePatient,
  createEpisode,
  getEpisode,
  updateEpisode,
  getEpisodeConclusion,
  saveEpisodeConclusion,
  getEpisodeConclusionSuggestion,
  getDailyRecords,
  createDailyRecord,
  updateDailyRecord,
  submitDailyRecord,
  getDeviceEpisodes,
  createDeviceEpisode,
  updateDeviceEpisode,
  deleteDeviceEpisode,
  getMicrobiologyResults,
  createMicrobiologyResult,
  updateMicrobiologyResult,
  deleteMicrobiologyResult,
  getSurgeryEpisodes,
  createSurgeryEpisode,
  updateSurgeryEpisode,
  deleteSurgeryEpisode,
  getSurgeryWoundFollowUps,
  createSurgeryWoundFollowUp,
  updateSurgeryWoundFollowUp,
  submitSurgeryWoundFollowUp,
  getCase,
  getCaseTimeline,
  getCaseComments,
  createCaseComment,
  getCaseAttachments,
  uploadCaseAttachment,
  deleteCaseAttachment,
  getWards,
  createWard,
  updateWard,
  deleteWard,
  getAntibiotics,
  createAntibiotic,
  updateAntibiotic,
  deleteAntibiotic,
  getOrganisms,
  createOrganism,
  updateOrganism,
  deleteOrganism,
  getSpecimenTypes,
  createSpecimenType,
  updateSpecimenType,
  deleteSpecimenType,
  getMdroDefinitions,
  createMdroDefinition,
  updateMdroDefinition,
  deleteMdroDefinition,
  getInfectionTypes,
  createInfectionType,
  updateInfectionType,
  deleteInfectionType,
  getCatheterTypes,
  createCatheterType,
  updateCatheterType,
  deleteCatheterType,
  getSignals,
  createSignal,
  getSignal,
  createCaseFromSignal,
  linkSignalToCase,
  dismissSignal,
  getRules,
  createRule,
  updateRule,
  deleteRule,
  testRule,
  getCriteriaSets,
  createCriteriaSet,
  updateCriteriaSet,
  cloneCriteriaSetVersion,
  getCriteriaItems,
  createCriteriaItem,
  updateCriteriaItem,
  deleteCriteriaItem,
  getCases,
  createCase,
  transitionCase,
  assignCase,
  getCaseDiagnoses,
  createCaseDiagnosis,
  previewCaseCriteria,
  getCaseCriterionOverview,
  getCaseCriterionSnapshots,
  createCaseCriterionSnapshot,
  getCaseVaeAssessments,
  createCaseVaeAssessment,
  updateCaseVaeAssessment,
  getCaseClabsiAssessments,
  createCaseClabsiAssessment,
  updateCaseClabsiAssessment,
  getCaseCautiAssessments,
  createCaseCautiAssessment,
  updateCaseCautiAssessment,
  getAuditLogs,
  exportAuditLogs,
  getUserProfiles,
  searchStaffForScope,
  upsertUserProfile,
  deleteUserProfile,
  getClusters,
  getCluster,
  createCluster,
  transitionCluster,
  linkClusterCase,
  openClusterFromSignal,
  getPeriodLocks,
  getPeriodReconciliation,
  createPeriodLock
}

export default SurveillanceRepository
